<template>
  <v-menu
    v-model="menuOpen"
    :close-on-content-click="false"
    close-on-click
    offset-y
  >
    <template #activator="{ on }">
      <v-chip
        large
        close
        close-icon="$snExitCircle"
        color="snBrand02"
        class="filter-chip sn-body-1"
        data-cy="filter-chip"
        v-on="on"
        @click:close="clearFilters"
      >
        {{ header.text }} ({{ numActive }})
        <v-icon class="ml-3 mr-3">
          {{ menuOpen ? '$snChevronUp' : '$snChevronDown' }}
        </v-icon>
      </v-chip>
    </template>

    <sort-and-filter-menu
      hide-sort
      :filter-options="header.filterBy"
      hide-clear-all-filters
      hide-filter-search
      :cy-tag="header.value"
      @filters:change="applyChanges"
      @filters:load-more="$emit('chip-filters:load-more', header.value)"
    />
  </v-menu>
</template>
<script>
import SortAndFilterMenu from './menu.vue'

export default {
  name: 'FilterChip',
  components: { SortAndFilterMenu },
  props: {
    header: {
      type: Object,
      required: true
    }
  },
  data: () => {
    return {
      menuOpen: false,
      searchedFilters: []
    }
  },
  computed: {
    areStaticFilters () {
      return Array.isArray(this.header.filterBy)
    },
    numActive () {
      const filters = this.header.filterBy.nodes ?? this.header.filterBy
      return filters.filter(f => f.active).length
    }
  },
  methods: {
    clearFilters () {
      const clearedFilters = {
        filters: {}
      }

      if (this.header.filterBy.nodes) {
        clearedFilters.filters = {
          ...this.header.filterBy,
          nodes: this.header.filterBy.nodes.map(f => {
            f.active = false
            return f
          })
        }
      } else {
        clearedFilters.filters = this.header.filterBy.map(f => {
          f.active = false
          return f
        })
      }

      this.applyChanges(clearedFilters)
    },
    applyChanges (changes) {
      this.menuOpen = false

      if (changes.filters) {
        changes.filters = {
          col: this.header.value,
          filters: changes.filters
        }

        this.$emit('chip-filters:change', changes.filters)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~/assets/css/snui';

.filter-chip {
  height: 48px !important;
  margin-left: 16px;
  font-weight: 600 !important;
}

.chip-filter__menu {
  width: 250px;
}

</style>
